// extracted by mini-css-extract-plugin
module.exports = {"legalText":"legalText_legalText__QN1Cf","header":"legalText_header__kQssG","content":"legalText_content__c8M7s","darkBlue":"legalText_darkBlue__JQw9z"};